<mat-icon [svgIcon]="getToggleIcon()" class="toggle" (click)="toggleSearch()"></mat-icon>
<input
  class="input"
  [class.open]="toggleState"
  type="text"
  [formControl]="input"
  autocomplete="off"
  [linToolbarSearchResults]="results"
  placeholder="{{ 'MAIN.SEARCH' | translate }}"
/>

<lin-toolbar-search-results #results="linToolbarSearchResults" (opened)="resetKeyManager()">
  @if (isLoading) {
  <div class="spinner-container">
    <mat-spinner diameter="35"></mat-spinner>
  </div>
  }

  <div class="result-rows-container">
    @for (result of searchResult; track $index) { @if (result.type === SearchResultType.Client) {
    <div class="result-group">{{ 'ADMIN.CLIENTS.CLIENTS' | translate }}</div>
    @for (client of result.items; track client.id) {
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="result-row">
        <a
          class="result-row-link"
          linToolbarSearchResultRow
          routerLink="{{ getClientUrl(client.id) }}"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
        <a class="result-row-header" routerLink="{{ getClientUrl(client.id) }}" target="_blank" rel="noopener noreferrer"
          >{{ client.name }}</a
        ><br />
      </div>
      @if (client.status === 'deleted') {
      <mat-icon svgIcon="delete"></mat-icon>
      }
    </div>
    } } @if (result.type === SearchResultType.User) {
    <div class="result-group">{{ 'ADMIN.CLIENTS.USERS.USERS' | translate }}</div>
    @for (user of result.items; track user.id) {
    <div class="result-row">
      <span class="result-row-header">{{ user.fullName }}</span>
      /
      <a [routerLink]="['admin/clients', user.team?.clientId, 'company-info']" target="_blank" rel="noopener noreferrer"
        >{{ user.team?.clientName }}</a
      >
      <br />
      <div fxLayout="row" fxLayoutAlign="start center">
        <span class="result-row-info">
          <ng-container
            *ngTemplateOutlet="user.status !== 'deleted' ? link : text; context: { link: getUserUrl(user), text: user.email }"
          ></ng-container>
          /
          <ng-container
            *ngTemplateOutlet="user.status !== 'deleted' ? link : text; context: { link: getUserUrl(user), text: user.phone }"
          ></ng-container>
        </span>
        @if (user.status === 'deleted') {
        <button class="undelete-button" type="button" (click)="undeleteUser(user.id)" [matTooltip]="'BUTTONS.UNDELETE' | translate">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
        }
      </div>
    </div>
    } } @if (result.type === SearchResultType.Device) {
    <div class="result-group">{{ 'ADMIN.DEVICES.DEVICES' | translate }}</div>
    @for (device of result.items; track device.id) {
    <div class="result-row">
      <a
        class="result-row-link"
        linToolbarSearchResultRow
        routerLink="{{ getDeviceUrl(device.id) }}"
        target="_blank"
        rel="noopener noreferrer"
      ></a>
      <span class="result-row-header">{{ device.model.name }}</span>
      <br />

      <span class="result-row-info">
        <a routerLink="{{ getDeviceUrl(device.id) }}" target="_blank" rel="noopener noreferrer">{{ device.model.name }}</a>
        / <a routerLink="{{ getDeviceUrl(device.id) }}" target="_blank" rel="noopener noreferrer">{{ device.imei }}</a> @if (device.phone) {
        / <a routerLink="{{ getDeviceUrl(device.id) }}" target="_blank" rel="noopener noreferrer">{{ device.phone }}</a> } @if (device.sn) {
        / <a routerLink="{{ getDeviceUrl(device.id) }}" target="_blank" rel="noopener noreferrer">{{ device.sn }}</a> } @if (device.vehicle)
        { / <a routerLink="{{ getVehicleUrl(device.id) }}" target="_blank" rel="noopener noreferrer">{{ device.vehicle.regNo }}</a> } @if
        (device.team.clientName) { /
        <a routerLink="{{ getClientUrl(device.team.clientId) }}" target="_blank" rel="noopener noreferrer">{{ device.team.clientName }}</a>
        } @if (device.status === 'deleted') {
        <mat-icon svgIcon="delete"></mat-icon>
        }
      </span>
    </div>
    } } @if (result.type === SearchResultType.Vehicle) {
    <div class="result-group">{{ 'CONFIGURATION.FLEET.VEHICLES' | translate }}</div>
    @for (vehicle of result.items; track vehicle.id) {
    <div class="result-row">
      @if (vehicle.status !== 'deleted') {
      <a
        class="result-row-link"
        linToolbarSearchResultRow
        href="{{ getVehicleUrl(vehicle) }}"
        (click)="onVehicleClick($event, vehicle)"
      ></a>
      }
      <span class="result-row-header">{{ vehicle.regNo }}</span>
      <br />

      <div class="result-row-info-wrapper">
        <span class="result-row-info">
          <ng-container
            *ngTemplateOutlet="vehicle.status !== 'deleted' ? vehicleLink : text; context: { vehicle: vehicle, text: vehicle.defaultLabel }"
          ></ng-container>
          @if (vehicle.model) { /
          <ng-container
            *ngTemplateOutlet="vehicle.status !== 'deleted' ? vehicleLink : text; context: { vehicle: vehicle, text: vehicle.model }"
          ></ng-container>
          } /
          <a routerLink="{{ getClientUrl(vehicle.team.clientId) }}" target="_blank" rel="noopener noreferrer"
            >{{ vehicle.team.clientName }}</a
          >
          /
          <ng-container
            *ngTemplateOutlet="vehicle.status !== 'deleted' ? vehicleLink : text; context: { vehicle: vehicle, text: vehicle.id }"
          ></ng-container>
        </span>
        @if (vehicle.status === 'deleted') {
        <button class="undelete-button" type="button" (click)="undeleteVehicle(vehicle.id)" [matTooltip]="'BUTTONS.UNDELETE' | translate">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
        }
      </div>
    </div>
    } } @if (result.type === SearchResultType.Geofence) {
    <div class="result-group">{{ 'CONFIGURATION.GEOFENCES_TITLE' | translate }}</div>
    @for (geofence of result.items; track geofence.id) {
    <div class="result-row">
      <a
        class="result-row-link"
        linToolbarSearchResultRow
        href="{{ getGeofenceUrl() }}"
        (click)="$event.preventDefault(); authService.impersonateAsClient(geofence.team.clientId, '/client/configuration/geofences')"
      ></a>
      <a class="result-row-header" href="{{ getGeofenceUrl() }}" (click)="onGeofenceClick($event, geofence.team.clientId)">
        {{ geofence.name }}
      </a>
      @if (geofence.status === 'deleted') {
      <mat-icon svgIcon="delete"></mat-icon>
      }
    </div>
    } } }
  </div>

  @if (searchResult && !searchResult.length) {
  <div class="no-result">{{ 'TOOLBAR.NO_RESULTS' | translate }}</div>
  }
</lin-toolbar-search-results>

<ng-template #link let-link="link" let-text="text">
  <a [routerLink]="link" target="_blank" rel="noopener noreferrer">{{ text }}</a>
</ng-template>

<ng-template #vehicleLink let-vehicle="vehicle" let-text="text">
  <a href="{{ getVehicleUrl(vehicle) }}" (click)="onVehicleClick($event, vehicle)">{{ text }}</a>
</ng-template>

<ng-template #text let-text="text">
  <span>{{ text }}</span>
</ng-template>
